import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PRIMARY_COLOR } from '../../styles/colors'
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

const MUIAccordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
}));
  
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ExpandMoreIcon sx={{ fontSize: '0.9rem', color: props.active ? '#fff' : '#000' }} />}
      {...props}
    />
  ))(({ theme, ...props }) => ({
    backgroundColor: props.active ? PRIMARY_COLOR : 'transparent',
    color: props.active ? '#fff' : '#000',
    borderRadius: '5px',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 7px 0 5px',
    '& .MuiAccordionSummary-expandIconWrapper': {
      display: props.links == 0 ? 'none' : 'flex'  
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',

    },
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(1),
    },
}));
  
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: '5px 0 5px 15px',
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const Accordion = ({ link, active = false }) => {
    const location = useLocation()
    const [expanded, setExpanded] = useState(active);

    const togglePanel = () => () => {
        setExpanded(!expanded);
    };

    const getActiveLink = (link) => {
        return Boolean(location.pathname.toLowerCase().indexOf(link.toLowerCase()) > -1)
    } 
  
    return (
        <MUIAccordion expanded={expanded} onChange={togglePanel()}>
            <AccordionSummary active={active} links={link?.subMenus?.length || 0} >
                {link.icon} <Typography fontSize={14}>{link.title}</Typography>
            </AccordionSummary>
              <AccordionDetails>
                  {
                      link.details
                  }
              </AccordionDetails>
        </MUIAccordion>
    )
};

export default Accordion;
